import { useSearchParams } from "react-router-dom";

export function useMobileEmbed() {
  const [searchParams] = useSearchParams();
  return searchParams.get("mobile") === "1";
}
